import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {fetchSubComments, resetSubComments} from "../../../../../creators/comments.subComments";
import {createSubComment, deleteSubComment, updateSubComment} from "../../../../../creators/comments.subComment";
import {subCommentByParentId} from "../../../../../selectors/subComments";

import SubComment from "./SubComment";
import Icon from "../../../Icon";
import {SpinLoader} from "../../../Loader";
import _ from "lodash";
import {reportSubComment} from "../../../../../creators/report";

class SubCommentList extends React.Component {
    constructor(props){
        super(props);
        this.filter = {
            limit: 5,
            page: 1,
            sort: "-createdAt",
        };
        this.state = {
            filter: this.filter,
            toggleSubComment: false,
            hasSubComment: true,
        };

        this.handleToggleSubComment = this.handleToggleSubComment.bind(this);
        this.reloadComments = this.reloadComments.bind(this);
        this.commentsNext = this.commentsNext.bind(this);
        this.updateSubComment = this.updateSubComment.bind(this);
        this.deleteSubComment = this.deleteSubComment.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        //
        // this.fetchSubComments(this.filter, false);
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.toggleSubComment !== this.state.toggleSubComment && this.state.toggleSubComment) {
            // this.props.resetSubComments(this.props.commentId);
            this.setState({filter: this.filter}, () => this.fetchSubComments(this.filter, false));
        }
        if((prevProps.isAnsweringComment !== this.props.isAnsweringComment) && (this.props.commentId === this.props.subCommentAnswer.commentId)){
            //when first comment is posted, show it
            this.setState({toggleSubComment: true});
        }
    }

    fetchSubComments(filter, more){
        filter = {...filter};
        this.props.fetchSubComments(this.props.commentType, this.props.parentId, this.props.commentId, filter, more);
    }

    reloadComments() {
        let filter = {...this.state.filter, page: 1};
        // this.props.resetSubComments(this.props.subCommentsKeysByCommentId);
        this.setState({filter}, () => this.fetchSubComments(filter, false));
    }

    commentsNext() {
        let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.fetchSubComments(newFilter, true);
    }

    updateSubComment(id, value) {
        this.props.updateSubComment(this.props.commentType, this.props.parentId, this.props.commentId, id, {content: value});
        this.reloadComments();
    }

    deleteSubComment(id) {
        this.props.deleteSubComment(this.props.commentType, this.props.parentId, this.props.commentId, id);
        this.reloadComments();
    }

    handleToggleSubComment(){
        this.setState({toggleSubComment: !this.state.toggleSubComment}, ()=> this.state.toggleSubComment ? this.fetchSubComments(this.state.filter) : null);
    }

    handleReport(id, message){
        this.props.reportSubComment(this.props.commentType, this.props.parentId, this.props.commentId, id, {message})
    }

    handleSubmit(value){
        this.props.createSubComment(this.props.commentType, this.props.parentId, this.props.commentId, value);
        this.setState({toggleSubComment: true, toggleAnswer: false});
    }

    render(){
        let subComments = [...this.props.subComments];
        return(
            <Fragment>
                {this.state.toggleSubComment && this.props.subCommentsMore && (
                    <span className="show-more-subcomment"
                          onClick={() => this.commentsNext()}>Voir plus de commentaires</span>
                )}
                {this.props.subCommentsLoading && this.props.subCommentsMore && (
                    <div className="more-comments loading" onClick={() => this.commentsNext()}>
                        <SpinLoader className={"small"}/>
                    </div>
                )}
                {this.state.toggleSubComment && (
                    <div className="all-sub-comment">
                        {!this.props.subCommentsInitialized && _.times(1).map((item, index) => (
                            <SubComment key={index} commentsInitialized={false}/>
                        ))}

                        {subComments.reverse().map(subComment => (
                            <SubComment key={subComment._id}
                                        {...subComment}
                                        currentUser={this.props.currentUser}
                                        commentsInitialized={this.props.subCommentsInitialized}
                                        subCommentsSubmitting={this.props.subCommentsSubmitting}
                                        deleteSubComment={this.deleteSubComment}
                                        updateSubComment={this.updateSubComment}
                                        handleEdit={this.props.handleEdit}
                                        handleReport={this.handleReport}
                                        handleSubCommentAnswer={this.props.handleSubCommentAnswer}
                                        // handleSubmit={this.handleSubmit}
                                        parentId={this.props.parentId}
                                        commentId={this.props.commentId}
                                        subCommentType={this.props.commentType}
                                        subCommentAnswer={this.state.subCommentAnswer}
                            />
                        ))}
                    </div>
                )}
                {!this.state.toggleSubComment && (this.props.subCommentsTotal >= 1 || this.props.hasSubComments) &&
                    <span className="more-comment-from-comment" onClick={() => this.handleToggleSubComment()}>
                       <Icon type="share"/>Afficher les réponses
                    </span>
                }
                {this.state.toggleSubComment && subComments.length >= 1 &&
                    <span className="more-comment-from-comment" onClick={() => this.handleToggleSubComment()}>
                       <Icon type="arrow-up"/> Cacher les réponses
                    </span>
                }
            </Fragment>
       )
    }
}

const mapStateToProps = (state, props) => {
    return {
        subComments: subCommentByParentId(state, props).data,
        // subCommentsKeysByCommentId: subCommentsKeysByCommentId(state, props),
        subCommentsLoading: subCommentByParentId(state, props).loading,
        subCommentsInitialized: subCommentByParentId(state, props).initialized,
        subCommentsSubmitting: subCommentByParentId(state, props).submitting,
        subCommentsMore: subCommentByParentId(state, props).more,
        subCommentsTotal: subCommentByParentId(state, props).total,

        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchSubComments,
    createSubComment,
    updateSubComment,
    deleteSubComment,
    resetSubComments,
    reportSubComment,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SubCommentList);